<template>
  <DanhSachCapDonVi />
</template>

<script>
import DanhSachCapDonVi from "@/components/pages/quan-tri-he-thong/cap-don-vi/DanhSachCapDonVi";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

export default {
  name: "TrangDanhSachCapDonVi",
  components: {
    DanhSachCapDonVi
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_DON_VI.NAME
      }`
    );
  }
};
</script>


